import React  from 'react';
import BooleanComponentProto from './boolean-proto.jsx';


export default function renderBooleanInEdit(id, props) {
    return <BooleanComponentProto renderMode="edit" id={id} {...props} />;
}